import {
  SET_MAIN_DATA_CHILD,
  CHANGE_MAIN_DATA_CHILD,
  BLUR_MAIN_DATA_CHILD,
  LOAD_DRAFT_EMPTY
} from '../constants';

const initialState = {
  data: {},
  editableFields: {},
  blur: {},
  firstState: null
};

const mainDataChild = (state = initialState, action) => {
  switch (action.type) {
    case SET_MAIN_DATA_CHILD:
      return {
        ...state,
        ...action.payload,
        blur: {},
        firstState: { ...action.payload }
      };
    case BLUR_MAIN_DATA_CHILD:
      return {
        ...state,
        blur: {
          ...state.blur,
          [action.payload]: true
        }
      };
    case CHANGE_MAIN_DATA_CHILD:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload.data
        },
        blur: {
          ...state.blur,
          [action.payload.field]: false
        }
      };
    case LOAD_DRAFT_EMPTY:
      return {
        ...initialState,
        ...state.firstState,
        firstState: { ...state.firstState }
      };
    default:
      return state;
  }
};

export default mainDataChild;
